"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  CheckPaymentGive: ['check-payment-give', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75,18v.75A2.25,2.25,0,0,1,13.5,21H3.75a3,3,0,0,1-2.684-1.658', 'M3.75,15h1.5a3,3,0,0,0,3-3H10.5a2.25,2.25,0,0,0,0-4.5H3.75a3,3,0,0,0-3,3', 'M5.25,7.5v-3A1.5,1.5,0,0,1,6.75,3h15a1.5,1.5,0,0,1,1.5,1.5v9a1.5,1.5,0,0,1-1.5,1.5h-12', 'M18.75,15a3,3,0,0,1-3,3h-6', 'M15.75 7.5L23.25 7.5', 'M17.25 10.5L20.25 10.5']],
  CashPaymentSign2: ['cash-payment-sign-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.212,15.637l-3.712.53.53-3.712,9.546-9.546a2.25,2.25,0,1,1,3.182,3.182Z', 'M5.25,8.25h-3a1.5,1.5,0,0,0-1.5,1.5v10.5a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5V9.75a1.5,1.5,0,0,0-1.5-1.5h-1.5', 'M20.25 18L12.75 18', 'M20.25 14.25L15.75 14.25']],
  CheckPaymentSign: ['check-payment-sign', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,20.25l1.23-1.079A1.8,1.8,0,0,1,7.324,18.8a1.541,1.541,0,0,1,1.151,1.036l.118.412,1.339-.783A1.811,1.811,0,0,1,12,19.646', 'M4.5,10.5l-2.244-.009a1.5,1.5,0,0,0-1.506,1.5V21.75a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5V11.991a1.5,1.5,0,0,0-1.5-1.5l-3,.009', 'M16.500 13.500 L20.250 13.500 L20.250 16.500 L16.500 16.500 Z', 'M10.393,14.539,6.151,15.6l1.06-4.242,8.782-8.782a2.251,2.251,0,0,1,3.182,0h0a2.251,2.251,0,0,1,0,3.182Z', 'M13.045 5.523L16.227 8.705', 'M16.227,2.341,15.166,1.28a1.5,1.5,0,0,0-2.121,0L9.863,4.462', 'M19.175 2.575L21 0.75']],
  CashPaymentSign1: ['cash-payment-sign-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.242 11.266L5.181 15.508 9.424 14.448 15.788 8.084 12.606 4.902 6.242 11.266z', 'M19.5,4.371l1.061,1.061a1.5,1.5,0,0,1,0,2.121L17.25,10.864', 'M15.788,8.084,19.5,4.371a1.5,1.5,0,0,0,0-2.121L18.439,1.189a1.5,1.5,0,0,0-2.121,0L12.606,4.9', 'M3.75,9.75H2.25a1.5,1.5,0,0,0-1.5,1.5v10.5a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5V11.25a1.5,1.5,0,0,0-1.5-1.5', 'M20.25 19.5L10.5 19.5', 'M20.25 15.75L13.5 15.75']]
};
exports["default"] = _default;